(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/hooks/use-search-results.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/hooks/use-search-results.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useMemo = _React.useMemo,
  useCallback = _React.useCallback;
const useSearchParams = svs.components.casino_react.hooks.useSearchParams;
const _svs$components$casin = svs.components.casino_react.casinoStore.endpoints.searchApi,
  useGetSearchResultQuery = _svs$components$casin.useGetSearchResultQuery,
  useLazyGetSearchResultQuery = _svs$components$casin.useLazyGetSearchResultQuery,
  useGetListFilterResultQuery = _svs$components$casin.useGetListFilterResultQuery,
  useLazyGetListFilterResultQuery = _svs$components$casin.useLazyGetListFilterResultQuery;
const DefaultNumberOfCasinoGridItems = svs.components.casino_react.common.constants.DefaultNumberOfCasinoGridItems;
const getHasSearchInput = _ref => {
  let searchQuery = _ref.searchQuery,
    tags = _ref.tags,
    providers = _ref.providers,
    listIds = _ref.listIds,
    categories = _ref.categories,
    sorting = _ref.sorting;
  return Boolean(searchQuery || (tags === null || tags === void 0 ? void 0 : tags.length) || (listIds === null || listIds === void 0 ? void 0 : listIds.length) || (providers === null || providers === void 0 ? void 0 : providers.length) || (categories === null || categories === void 0 ? void 0 : categories.length) || (sorting === null || sorting === void 0 ? void 0 : sorting.length));
};
const getHasOnlyListId = _ref2 => {
  let listIds = _ref2.listIds,
    searchQuery = _ref2.searchQuery,
    tags = _ref2.tags,
    providers = _ref2.providers,
    categories = _ref2.categories,
    sorting = _ref2.sorting;
  return Boolean(listIds === null || listIds === void 0 ? void 0 : listIds.length) && !getHasSearchInput({
    searchQuery,
    tags,
    providers,
    categories,
    sorting
  });
};
const buildQueryOptions = shouldSkip => ({
  skip: shouldSkip,
  selectFromResult: result => {
    if (shouldSkip || !(result !== null && result !== void 0 && result.data)) {
      return {
        data: {
          games: null,
          error: null,
          totalCount: null
        }
      };
    }
    return result;
  }
});

const useSearchResults = function () {
  var _listIds$;
  let _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref3$fetchCount = _ref3.fetchCount,
    fetchCount = _ref3$fetchCount === void 0 ? DefaultNumberOfCasinoGridItems * 3 : _ref3$fetchCount,
    _ref3$fetchOffset = _ref3.fetchOffset,
    fetchOffset = _ref3$fetchOffset === void 0 ? 0 : _ref3$fetchOffset,
    _ref3$skipGamesSearch = _ref3.skipGamesSearch,
    skipGamesSearch = _ref3$skipGamesSearch === void 0 ? false : _ref3$skipGamesSearch;

  const _useState = useState(fetchCount),
    _useState2 = _slicedToArray(_useState, 1),
    count = _useState2[0];
  const _useState3 = useState(fetchOffset),
    _useState4 = _slicedToArray(_useState3, 2),
    offset = _useState4[0],
    setOffset = _useState4[1];
  const _useSearchParams = useSearchParams(),
    queryString = _useSearchParams.q,
    tags = _useSearchParams.tags,
    categories = _useSearchParams.categories,
    listIds = _useSearchParams.listIds,
    decodedProviders = _useSearchParams.providers,
    sorting = _useSearchParams.sorting;
  const providers = decodedProviders === null || decodedProviders === void 0 ? void 0 : decodedProviders.map(encodeURIComponent);
  const hasSearchInput = getHasSearchInput({
    searchQuery: queryString,
    tags,
    providers,
    listIds,
    categories
  });
  const hasOnlyListId = getHasOnlyListId({
    searchQuery: queryString,
    tags,
    providers,
    listIds,
    categories,
    sorting
  });
  const _useGetSearchResultQu = useGetSearchResultQuery({
      searchQuery: queryString,
      tags,
      providers,
      listIds,
      categories,
      count,
      offset,
      sorting
    }, buildQueryOptions(skipGamesSearch || hasOnlyListId || !hasSearchInput)),
    searchData = _useGetSearchResultQu.data,
    searchDataIsLoading = _useGetSearchResultQu.isLoading,
    searchDataError = _useGetSearchResultQu.error,
    searchDataIsFetching = _useGetSearchResultQu.isFetching;
  const _useLazyGetSearchResu = useLazyGetSearchResultQuery(),
    _useLazyGetSearchResu2 = _slicedToArray(_useLazyGetSearchResu, 1),
    searchFetchMore = _useLazyGetSearchResu2[0];
  const searchFetchMoreOffset = useCallback((offset, count) => {
    searchFetchMore({
      offset,
      count,
      searchQuery: queryString,
      tags,
      providers,
      categories,
      listIds,
      sorting
    });
  }, [categories, listIds, providers, queryString, searchFetchMore, sorting, tags]);
  const _useGetListFilterResu = useGetListFilterResultQuery({
      listId: (_listIds$ = listIds === null || listIds === void 0 ? void 0 : listIds[0]) !== null && _listIds$ !== void 0 ? _listIds$ : '',
      count,
      offset
    }, buildQueryOptions(skipGamesSearch || !hasOnlyListId)),
    listData = _useGetListFilterResu.data,
    listDataIsLoading = _useGetListFilterResu.isLoading,
    listDataError = _useGetListFilterResu.error,
    listDataIsFetching = _useGetListFilterResu.isFetching;
  const _useLazyGetListFilter = useLazyGetListFilterResultQuery(),
    _useLazyGetListFilter2 = _slicedToArray(_useLazyGetListFilter, 1),
    listFetchMore = _useLazyGetListFilter2[0];
  const listFetchMoreOffset = useCallback((offset, count) => {
    var _listIds$2;
    listFetchMore({
      listId: (_listIds$2 = listIds === null || listIds === void 0 ? void 0 : listIds[0]) !== null && _listIds$2 !== void 0 ? _listIds$2 : '',
      offset,
      count
    });
  }, [listFetchMore, listIds]);
  const result = useMemo(() => ({
    games: hasOnlyListId ? listData === null || listData === void 0 ? void 0 : listData.games : searchData === null || searchData === void 0 ? void 0 : searchData.games,
    totalGamesCount: hasOnlyListId ? listData === null || listData === void 0 ? void 0 : listData.totalCount : searchData === null || searchData === void 0 ? void 0 : searchData.totalCount,
    error: hasOnlyListId ? listDataError : searchDataError,
    isLoading: hasOnlyListId ? listDataIsLoading : searchDataIsLoading,
    isFetching: hasOnlyListId ? listDataIsFetching : searchDataIsFetching,
    latestSearchQuery: queryString,
    offset,
    setOffset,
    fetchMore: hasOnlyListId ? listFetchMoreOffset : searchFetchMoreOffset
  }), [hasOnlyListId, searchData === null || searchData === void 0 ? void 0 : searchData.games, searchData === null || searchData === void 0 ? void 0 : searchData.totalCount, searchDataError, searchDataIsFetching, searchDataIsLoading, searchFetchMoreOffset, listData === null || listData === void 0 ? void 0 : listData.games, listData === null || listData === void 0 ? void 0 : listData.totalCount, listDataError, listDataIsFetching, listDataIsLoading, listFetchMoreOffset, offset, queryString]);
  return result;
};
setGlobal('svs.components.casino_react.casinoStore.hooks.useSearchResults', useSearchResults);

 })(window);